export default "__VITE_ASSET__7297fc0e__"